import { format as dateFnsFormat, startOfWeek, getDay, parse } from "date-fns"
import { dateFnsLocales } from "@/modules/calendar/config/date-fns-config"

const config = {
  format: dateFnsFormat,
  parse,
  startOfWeek: (date: Date) => startOfWeek(date, { weekStartsOn: 1 }),
  getDay,
  locales: dateFnsLocales,
}

export default config
